exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modern-form[data-v-fec0f5a8] .el-form-item {\n  margin-bottom: 20px;\n}\n.modern-form[data-v-fec0f5a8] .el-form-item__label {\n  font-weight: 600;\n  color: #475569;\n  padding-bottom: 6px;\n}\n.modern-form[data-v-fec0f5a8] .el-input__inner {\n  border-radius: 8px;\n  height: 40px;\n}\n.full-width[data-v-fec0f5a8] {\n  width: 100% !important;\n}\n.full-width[data-v-fec0f5a8] .el-input__inner {\n    width: 100% !important;\n}\n", ""]);

// exports
